import { FC, ReactNode } from "react";
import styles from "./ProminentAlert.module.scss";

export interface ProminentAlertProps {
  icon?: ReactNode;
  title?: ReactNode;
  children?: ReactNode;
}

export const ProminentAlert: FC<ProminentAlertProps> = ({
  icon = "👈",
  title,
  children,
}) => {
  const defaultTitle = (
    <>
      <span className={styles.desktopOnly}>
        Please see the key test areas on the left sidebar
      </span>
      <span className={styles.mobileOnly}>
        Please open the nav menu on the top left to see the key test areas
      </span>
    </>
  );

  const defaultChildren = (
    <>
      <span className={styles.desktopOnly}>
        Explore the main functional sections and test areas directly via the sidebar navigation on the left.
      </span>
      <span className={styles.mobileOnly}>
        Tap the menu button at the top left to explore the main functional sections and test areas.
      </span>
    </>
  );

  const resolvedTitle = title !== undefined ? title : defaultTitle;
  const resolvedChildren = children !== undefined ? children : defaultChildren;

  return (
    <div
      className={styles.prominentAlert}
      role="region"
      aria-label="Prominent alert"
    >
      <div className={styles.alertIcon} aria-hidden="true">
        {icon}
      </div>
      <div className={styles.alertContent}>
        <h2>{resolvedTitle}</h2>
        {typeof resolvedChildren === "string" ? (
          <p>{resolvedChildren}</p>
        ) : (
          <p>{resolvedChildren}</p>
        )}
      </div>
    </div>
  );
};
